<header class="col-12 px-1 header-page">
  <h1 class="header__page__content__title">
    Declaração das Condições de Saúde
  </h1>
</header>
<section>
  <blockquote class="mt-2 main-content-blockquote">
    A declaração de saúde tem por objetivo registrar a existência de doenças e lesões preexistentes, como sendo aquelas
    que o CONTRATANTE tenha conhecimento no momento da assinatura do contrato, em relação a si próprio ou a qualquer de
    seus dependentes e, ainda, em relação ao beneficiário titular sob a sua responsabilidade (menor, tutelado, etc).
  </blockquote>
</section>

<section class="grid-section">

  <div [ngClass]="{'loading': !loading}">
    <section class="spinner-overlay">
      <div class="spinner"></div>
    </section>
  </div>

  <main class="col-sm-12 col-xl-12 main__content" >
    <form class="col-12 px-1">
      <table>
        <tr class="col-12 px-1">
          <th class="col-1 px-1">Item</th>
          <th class="col-9 px-1">Enfermidade</th>
          <th class="col-2 px-1">Selecione</th>
        </tr>
        <tr class="col-12 px-1" *ngFor="let item of listaDeclaracaoSaudePlanoIII; let i = index">
          <td class="col-1 px-1">{{item.id}}</td>
          <td class="col-9 px-1">{{item.descricao}}</td>
          <td class="col-2 px-1">
            <div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" [id]="'radio_sim' + item.id" [name]="'radio_sim' + item.id"
                  class="custom-control-input" value="true" [(ngModel)]="item.incidencia"
                  (change)="clickCheckBox(true, item, i)">
                <label class="custom-control-label" [for]="'radio_sim' + item.id">Sim</label>
              </div>
              <div class="custom-control custom-radio custom-control-inline">
                <input type="radio" [id]="'radio_nao' + item.id" [name]="'radio_nao' + item.id"
                  class="custom-control-input" value="false" [(ngModel)]="item.incidencia"
                  (change)="clickCheckBox(false, item, i)">
                <label class="custom-control-label" [for]="'radio_nao' + item.id">Não</label>
              </div>
            </div>
          </td>
        </tr>
      </table>
    </form>
    <section *ngIf="listaAfirmativas.length > 0" [@fadeIn]>
      <div class="content-footer-descricao">
        <p class="mt-2">
          Em caso de resposta afirmativa (sim) para qualquer dos itens acima, informar os dados considerados importantes
          para análise médica,
          respondendo os quesitos:
        </p>
        <b class="mt-1 mb-1" style="font-size: 0.875rem !important;">
          Qual? Quando? Por quê? Onde? Conforme o caso.
        </b>
      </div>
      <table class="mt-1 col-12 px-1">
        <tr class="col-12 px-1">
          <th class="col-2 px-1">
            Item
          </th>
          <th class="col-2 px-1">
            Data do Evento
          </th>
          <th class="col-6 px-1">
            Esclarecimentos/Especificações
          </th>
        </tr>
        <tr class="col-12 px-1" *ngFor="let item of listaAfirmativas; let i = index" [@fadeInOut]>
          <td class="col-2 px-1">
            {{item.id}}
          </td>
          <td class="col-2 px-1 form-group">
            <input class="form-control input-declaracao-saude input-form input-form-details" type="date"
              max="{{today | date:'yyyy-MM-dd'}}" [(ngModel)]="item.dataEvento" [ngModelOptions]="{standalone: true}" />
          </td>
          <td class="col-6 px-1 form-group">
            <textarea class="form-control input-declaracao-saude" placeholder="Coloque aqui sua descrição"
              id="exampleFormControlTextarea1" rows="1" [(ngModel)]="item.esclarecimento"
              [ngModelOptions]="{standalone: true}">
                </textarea>
          </td>
        </tr>
      </table>
    </section>
    <div class="form-group form-observacao">
      <label for="exampleFormControlTextarea1">Observações</label>
      <textarea [(ngModel)]="observacoes" class="form-control" id="exampleFormControlTextarea1" rows="3"
        placeholder="Caso seja necessário informe alguma observação"></textarea>
    </div>
    <div class="form-check">
      <input type="checkbox" class="form-check-input" id="aceites" (change)="changeTermo()">
      <label class="form-check-label check-label" for="aceites">
        Declaro estar ciente de todas as informações acimas por mim declaradas e que sou responsável por todas elas.
      </label>
    </div>
  </main>
  <footer>
    <section class="content-buttons">
      <div class="form-actions my-4 ">
        <div class="div-button float-right">
          <button type="submit" class="btn btn-primary px-4" (click)="checkValues()"
            [disabled]="this.loading || !aceiteTermoAdesao">
            <span class="btn-span">Continuar</span>
          </button>
        </div>
      </div>
      <div class="form-actions my-4 ">
        <div class="div-button float-right">
          <button type="submit" class="btn btn-outline-primary px-4 mr-xl-1 mr-lg-1 mr-md-1 mr-sm-0">
            <span class="btn-span">Cancelar</span>
          </button>
        </div>
      </div>
    </section>
  </footer>
</section>